import React from 'react';
import { Link, Outlet } from 'react-router-dom';
import './Layout.css';
import FreioLabsLogo from '../assets/logo/FL-Logo-Blue-Circle-Bold-White-Beaker.png';

const Layout: React.FC = () => (
  <div className="layout">
    <a className="skip-link" href="#main-content">Skip to content</a>
    <header className="site-header">
      <nav className="nav-container" aria-label="Primary navigation">
        <Link to="/" className="nav-logo" aria-label="FreioLabs home">
          <img src={FreioLabsLogo} alt="" /> <span>FreioLabs</span>
        </Link>
        <div className="nav-links">
          <Link to="/services">Services</Link>
          <Link to="/about">About</Link>
          <Link to="/contact">Contact</Link>
        </div>
        <Link to="/contact" className="nav-cta">Start a project <span aria-hidden="true">↗</span></Link>
      </nav>
    </header>
    <main id="main-content" className="main-content"><Outlet /></main>
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-brand"><img src={FreioLabsLogo} alt="" /><p>Forward-looking digital products, shaped by human judgment.</p></div>
        <div><p className="footer-label">Explore</p><Link to="/services">Services</Link><Link to="/about">About FreioLabs</Link><Link to="/contact">Start a project</Link></div>
        <div><p className="footer-label">Contact</p><a href="mailto:hello@freiolabs.com">hello@freiolabs.com</a><a href="mailto:legal@freiolabs.com">legal@freiolabs.com</a></div>
      </div>
      <div className="footer-bottom"><span>© {new Date().getFullYear()} FreioLabs</span><span><Link to="/privacy">Privacy</Link><Link to="/terms">Terms</Link><Link to="/liability">Liability</Link></span></div>
    </footer>
  </div>
);

export default Layout;
